export default class ChangeHandler {

    private static getObjProperties(obj) {
        let objProperties = [];
        let val = ko.unwrap(obj);

        if (val !== null && typeof val === 'object') {
            for (let i in val) {
                if (val.hasOwnProperty(i)) {
                    objProperties.push({ 'name': i, 'value': val[i] });
                }
            }
        }

        return objProperties;
    }

    public static traverseObservables(obj, action) {
        ko.utils.arrayForEach(ChangeHandler.getObjProperties(obj), (observable) => {
            if (observable && observable.value && !observable.value.nodeType && ko.isObservable(observable.value)) {
                action(observable);
            }
        });
    }

    public static applyChangeTrackingToObservable(observable: KnockoutObservable<any>) {
        if (observable && !observable.nodeType && !observable.refresh && ko.isObservable(observable)) {
            if (!observable.isDirty) {
                observable.extend({ trackChange: true });
            }
        }
    }

    public static applyChangeTracking(obj) {
        let properties = ChangeHandler.getObjProperties(obj);
        ko.utils.arrayForEach(properties, (property) => {
            ChangeHandler.applyChangeTrackingToObservable(property.value);
        });
    }

    public static getChangesFromModel(obj) {
        let changes = {};
        let properties = ChangeHandler.getObjProperties(obj);

        ko.utils.arrayForEach(properties, (property) => {
            if (property.value != null && property.value.isDirty != null && property.value.isDirty()) {
                changes[property.name] = property.value.getChanges();
            }
        });

        return changes;
    }

    public static commitChangesFromModel(obj, props) {
        let changes = ChangeHandler.getChangesFromModel(obj);

        for (let property in changes) {
            if (props == null || props.indexOf(property) > -1) {
                obj[property].commit();
            }
        }
    }

    public static revertChangesFromModel(obj, props) {
        let changes = ChangeHandler.getChangesFromModel(obj);

        for (let property in changes) {
            if (props == null || props.indexOf(property) > -1) {
                obj[property].revert();
            }
        }
    }

}